import {JsonProperty} from '../shared/decorators/json-property';
import {Constants} from '../shared/utils/constants';

export class Wallet {
  @JsonProperty('bitgo_transaction_id')
  bid: number;
  @JsonProperty('perfect_money_transaction_id')
  pid: number;
  @JsonProperty('sticpay_transaction_id')
  sid: number;
  username: string;
  status: number;
  type: number;
  asset: string;
  @JsonProperty('is_internal')
  isInternal: boolean;
  volume: number;
  txid: number;
  @JsonProperty('payment_id')
  paymentId: boolean;
  @JsonProperty('create_time')
  createdDate: string;
  @JsonProperty('approved_user')
  approver: string;
  constructor() {
    this.bid = undefined;
    this.pid = undefined;
    this.sid = undefined;
    this.paymentId = undefined;
    this.username = undefined;
    this.status = undefined;
    this.type = undefined;
    this.asset = undefined;
    this.isInternal = undefined;
    this.volume = undefined;
    this.txid = undefined;
    this.createdDate = undefined;
    this.approver = undefined;
  }

  getType(): any {
    switch (this.type) {
      case 1:
        return {
          name: 'Withdtaw',
          html: '<span class="text-red">Withdraw</span>',
        };
      case 0:
        return {
          name: 'Deposit',
          html: '<span class="text-green">Deposit</span>',
        };
      default:
        return {};
    }
  }

  getStatus(): any {
    return Constants.TRANSACTION_STATUS[this.status];
  }

  getNote(): any {
    switch (this.isInternal) {
      case true:
        return {
          name: 'Internal Transfer',
          html: '<span class="text-yellow">Internal Transfer</span>',
        };
      default:
        return {};
    }
  }
}


export class WalletCommonItem {
  @JsonProperty('deposit_charge')
  depositCharge: number;
  @JsonProperty('deposit_threshold')
  depositThreshold: number;
  @JsonProperty('min_deposit')
  minDeposit: number;
  @JsonProperty('withdraw_charge')
  withdrawCharge: number;
  @JsonProperty('withdraw_threshold')
  withdrawThreshold: number;
  constructor() {
    this.depositCharge = undefined;
    this.depositThreshold = undefined;
    this.minDeposit = undefined;
    this.withdrawCharge = undefined;
    this.withdrawThreshold = undefined;
  }
}
export class WalletSettingItem {
  @JsonProperty('min_withdraw')
  minwd: number;
  @JsonProperty('max_withdraw')
  maxwd: number;
  @JsonProperty('transaction_fee')
  fee: number;
  threshold: number;
  constructor() {
    this.minwd = undefined;
    this.maxwd = undefined;
    this.fee = undefined;
    this.threshold = undefined;
  }
}

export class WalletCommon {
  @JsonProperty({ clazz: WalletCommonItem, name: 'usd' })
  usd: WalletCommonItem;
  @JsonProperty({ clazz: WalletSettingItem, name: 'jpy' })
  jpy: WalletCommonItem;
  constructor() {
    this.usd = new WalletCommonItem();
    this.jpy = new WalletCommonItem();
  }
}

export class WalletCrypto {
  @JsonProperty({ clazz: WalletSettingItem, name: 'btc' })
  btc: WalletSettingItem;
  @JsonProperty({ clazz: WalletSettingItem, name: 'eth' })
  eth: WalletSettingItem;
  @JsonProperty({ clazz: WalletSettingItem, name: 'xrp' })
  xrp: WalletSettingItem;
  @JsonProperty({ clazz: WalletSettingItem, name: 'usdt' })
  usdt: WalletSettingItem;
  @JsonProperty('withdraw_fee')
  wdFee: number;
  constructor() {
    this.btc = new WalletSettingItem();
    this.eth = new WalletSettingItem();
    this.xrp = new WalletSettingItem();
    this.usdt = new WalletSettingItem();
    this.wdFee = undefined;
  }
}

export class WalletFiat {
  @JsonProperty({ clazz: WalletSettingItem, name: 'usd' })
  usd: WalletSettingItem;
  @JsonProperty({ clazz: WalletSettingItem, name: 'jpy' })
  jpy: WalletSettingItem;
  @JsonProperty('withdraw_fee_sticpay')
  wdFeeSticpay: number;
  @JsonProperty('withdraw_fee_pf_money')
  wdFeePerfectMoney: number;
  constructor() {
    this.usd = new WalletSettingItem();
    this.jpy = new WalletSettingItem();
    this.wdFeeSticpay = undefined;
    this.wdFeePerfectMoney = undefined;
  }
}

export class WalletSticpayItem {
  @JsonProperty('min_deposit')
  minDeposit: number;
  @JsonProperty('deposit_threshold')
  depositThreshold: number;
  @JsonProperty('transaction_fee_amount')
  transactionFeeAmount: number;
  @JsonProperty('transaction_fee_ratio')
  transactionFeeRatio: number;
  @JsonProperty('sticpay_fee')
  sticpayFee: number;
  constructor() {
    this.depositThreshold = undefined;
    this.minDeposit = undefined;
    this.transactionFeeAmount = undefined;
    this.transactionFeeRatio = undefined;
    this.sticpayFee = undefined;
  }
}

export class WalletSticpay {
  @JsonProperty({ clazz: WalletSticpayItem, name: 'usd' })
  usd: WalletSticpayItem;
  @JsonProperty({ clazz: WalletSticpayItem, name: 'jpy' })
  jpy: WalletSticpayItem;
  @JsonProperty('transaction_fee_mode')
  transactionFeeMode: 'amount' | 'ratio';
  constructor() {
    this.usd = new WalletSticpayItem();
    this.jpy = new WalletSticpayItem();
    this.transactionFeeMode = 'amount';
  }
}

export class WalletSetting {
  @JsonProperty({ clazz: WalletCommon, name: 'common' })
  common: WalletCommon;
  @JsonProperty({ clazz: WalletCrypto, name: 'crypto' })
  crypto: WalletCrypto;
  @JsonProperty({ clazz: WalletFiat, name: 'fiat' })
  fiat: WalletFiat;
  @JsonProperty({ clazz: WalletFiat, name: 'sticpay' })
  sticpay: WalletSticpay;
  @JsonProperty('exchange_fee')
  eFee: number;
  constructor() {
    this.crypto = new WalletCrypto();
    this.fiat = new WalletFiat();
    this.common = new WalletCommon();
    this.sticpay = new WalletSticpay();
    this.eFee = undefined;
  }
}

export class Deposit {
  @JsonProperty('user_id')
  id: number;
  @JsonProperty('banking_transaction_id')
  depositId: number;
  username: string;
  email: string;
  volume: number;
  @JsonProperty('deposit_withdrawl_fee')
  fee: number;
  asset: string;
  @JsonProperty('transaction_id')
  transactionId: number;
  @JsonProperty('approved_user')
  pic: string;
  @JsonProperty('create_time')
  time: number;
  constructor() {
    this.id = undefined;
    this.depositId = undefined;
    this.username = undefined;
    this.email = undefined;
    this.volume = undefined;
    this.fee = undefined;
    this.asset = undefined;
    this.transactionId = undefined;
    this.pic = undefined;
    this.time = undefined;
  }
}

export class ManualHistory {
  login: number;
  status: number;
  username: string;
  volume: number;
  @JsonProperty('create_time')
  createTime: number;
  constructor() {
    this.login = undefined;
    this.status = undefined;
    this.username = undefined;
    this.volume = undefined;
    this.createTime = undefined
  
  }
  getStatus(): string {
    let textColor = 'text-white'
    if(!this.status){
      return ''
    }
    switch (this.status) {
      case 0:
        textColor = 'text-green'
        break
      case 1:
        textColor = 'text-white'
        break
      case 2:
        textColor = 'text-red'
        break
    }
    return `
    <span class="${textColor}">
      ${Constants.MANUAL_HISTORY[this.status]}
    </span>`
    ;
  }
}